import { Inject, Injectable } from '@angular/core';
import { UserDetails } from '@app/shared/models/user/user-details';
import {
  AUTH_CONFIG,
  AuthConfig,
  Authentication,
  AuthenticationDetails,
  AuthenticationProviderService,
} from '@technocom/auth';
import { HttpService } from '@technocom/common/http';
import { JsonObject, JsonValue } from '@technocom/common/platform';
import { EntityProvider } from '@technocom/data';
import { Organization } from '@app/shared/models/organizations';
import { Entity } from '@technocom/data/core';
import { JsonArray } from '@technocom/common/platform/lib/json/json';
import { Role } from '@app/shared/models/user/role';

@Injectable()
export class UserProviderService extends AuthenticationProviderService {
  constructor(
    @Inject(EntityProvider) protected entityProvider: EntityProvider,
    @Inject(HttpService) http: HttpService,
    @Inject(Authentication) user: Authentication,
    @Inject(AUTH_CONFIG) options?: AuthConfig,
  ) {
    super(http, user, options);
  }

  protected parse(data: JsonObject): AuthenticationDetails & { organization: Organization } {
    const isGuest = (data.roles as JsonArray).some((role: JsonObject) => role.id === Role.GUEST);
    const user = this.entityProvider.getFactory(UserDetails).parse(data);
    if (user) {
      return {
        username: user.id,
        disabled: user.active !== true, // not больше не работает
        displayName: user.getName(),
        authorities: isGuest ? null : user.getAuthorities(),
        organization: user.getOrganization(),
      };
    }

    return super.parse(data) as AuthenticationDetails & { organization: Organization };
  }
}
